var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var PAGE_NAME = {
    ERROR: "error",
    VIEW: "view statements",
    API_FAILED: "api failed",
    REENROLLMENT_FAILED: "failed",
    UNENROLLED_NO_STATEMENTS_API_FAIL: "no statements api failed",
    NO_STATEMENTS: "no statements",
    DELINQUENT_STATUS: "delinquent account status",
};
export var DEFAULTS = {
    SUB_FUNCTION: "",
    PAGE_FUNCTION: "statements",
    PAGE_NAME: "",
    SITE_IDENTIFIER: "vista",
    DEVICE: "<mobi/desk/tab>",
    PNL: "vista",
    CUSTOMER_TYPE: "consumer",
    PRODUCT: "generic",
    ERROR_MESSAGE: "",
    MESSAGE: "",
    PAGE_KIND: "statements",
};
var AnalyticEvents;
(function (AnalyticEvents) {
    AnalyticEvents["CLICK"] = "clicktrackingevent";
})(AnalyticEvents || (AnalyticEvents = {}));
var CLICK_DEFAULTS = {
    "data-type": "statements",
    "data-object": "button",
    "data-analytics": AnalyticEvents.CLICK,
};
export var getClickAnalyticsProperties = function (_a) {
    var reason = _a.reason;
    return __assign(__assign({}, CLICK_DEFAULTS), { "data-reason": reason });
};
